'use strict';

module.exports = {
  'Washington DC,DC,United States': {
    searchLocation: 'Washington DC',
    area: 'DC Metro Area',
    aliases: [{
      city: 'Washington',
      state: 'DC',
      country: 'United States'
    }, {
      city: 'Arlington',
      state: 'VA',
      country: 'United States'
    }, {
      city: 'Alexandria',
      state: 'VA',
      country: 'United States'
    }, {
      city: 'Bethesda',
      state: 'MD',
      country: 'United States'
    }, {
      city: 'Silver Spring',
      state: 'MD',
      country: 'United States'
    }, {
      city: 'McLean',
      state: 'VA',
      country: 'United States'
    }, {
      city: 'Tysons',
      state: 'VA',
      country: 'United States'
    }, {
      city: 'Vienna',
      state: 'VA',
      country: 'United States'
    }, {
      city: 'Reston',
      state: 'VA',
      country: 'United States'
    }, {
      city: 'Leesburg',
      state: 'VA',
      country: 'United States'
    }, {
      city: 'Annandale',
      state: 'VA',
      country: 'United States'
    }, {
      city: 'Chevy Chase',
      state: 'MD',
      country: 'United States'
    }, {
      city: 'Potomac',
      state: 'MD',
      country: 'United States'
    }],
    map: {
      center: {
        lat: 38.890243,
        lng: -77.052677
      },
      zoom: 12,
      scrollwheel: false,
      mapTypeControl: false,
      streetViewControl: false,
      panControl: false,
      zoomControl: true
    }
  },
  'New York,NY,United States': {
    searchLocation: 'New York',
    area: 'New York',
    aliases: [{
      city: 'New York',
      state: 'NY',
      country: 'United States'
    }, {
      city: 'Brooklyn',
      state: 'NY',
      country: 'United States'
    }, {
      city: 'Jersey City',
      state: 'New Jersey',
      country: 'USA',
      priorityMultiplier: 0.5
    }],
    map: {
      center: {
        lat: 40.767519,
        lng: -73.954369
      },
      zoom: 12,
      scrollwheel: false,
      mapTypeControl: false,
      streetViewControl: false,
      panControl: false,
      zoomControl: true
    }
  },
  'Boston,MA,United States': {
    searchLocation: 'Boston',
    area: 'Boston Area',
    aliases: [{
      city: 'Boston',
      state: 'MA',
      country: 'United States'
    }, {
      city: 'Cambridge',
      state: 'MA',
      country: 'United States'
    }, {
      city: 'Somerville',
      state: 'MA',
      country: 'United States'
    }, {
      city: 'Brookline',
      state: 'MA',
      country: 'United States'
    }, {
      city: 'Arlington',
      state: 'MA',
      country: 'United States'
    }, {
      city: 'Waltham',
      state: 'MA',
      country: 'United States'
    }, {
      city: 'Milton',
      state: 'MA',
      country: 'United States'
    }, {
      city: 'Newton',
      state: 'MA',
      country: 'United States'
    }, {
      city: 'Medford',
      state: 'MA',
      country: 'United States'
    }, {
      city: 'Belmont',
      state: 'MA',
      country: 'United States'
    }, {
      city: 'Dedham',
      state: 'MA',
      country: 'United States'
    }, {
      city: 'Needham',
      state: 'MA',
      country: 'United States'
    }, {
      city: 'Wellesley',
      state: 'MA',
      country: 'United States'
    }, {
      city: 'Quincy',
      state: 'MA',
      country: 'United States'
    }, {
      city: 'Worcester',
      state: 'MA',
      country: 'United States'
    }, {
      city: 'Wellesley',
      state: 'MA',
      country: 'United States'
    }],
    map: {
      center: {
        lat: 42.363598,
        lng: -71.079534
      },
      zoom: 13,
      scrollwheel: false,
      mapTypeControl: false,
      streetViewControl: false,
      panControl: false,
      zoomControl: true
    }
  },
  'San Francisco,CA,United States': {
    searchLocation: 'San Francisco',
    area: 'San Francisco Bay Area',
    aliases: [{ city: 'San Francisco', state: 'CA', country: 'United States' }, { city: 'Berkeley', state: 'CA', country: 'United States' }, { city: 'Burlingame', state: 'CA', country: 'United States' }, { city: 'Cupertino', state: 'CA', country: 'United States' }, { city: 'Daly City', state: 'CA', country: 'United States' }, { city: 'East Palo Alto', state: 'CA', country: 'United States' }, { city: 'Half Moon Bay', state: 'CA', country: 'United States' }, { city: 'Menlo Park', state: 'CA', country: 'United States' }, { city: 'Mill Valley', state: 'CA', country: 'United States' }, { city: 'Mountain View', state: 'CA', country: 'United States' }, { city: 'Napa', state: 'CA', country: 'United States' }, { city: 'Oakland', state: 'CA', country: 'United States' }, { city: 'Palo Alto', state: 'CA', country: 'United States' }, { city: 'Petaluma', state: 'CA', country: 'United States' }, { city: 'Redwood City', state: 'CA', country: 'United States' }, { city: 'San Francisco', state: 'CA', country: 'United States' }, { city: 'San Jose', state: 'CA', country: 'United States' }, { city: 'San Mateo', state: 'CA', country: 'United States' }, { city: 'Santa Clara', state: 'CA', country: 'United States' }, { city: 'Sonoma', state: 'CA', country: 'United States' }, { city: 'St. Helena', state: 'CA', country: 'United States' }, { city: 'Sunnyvale', state: 'CA', country: 'United States' }, { city: 'Walnut Creek', state: 'CA', country: 'United States' }, { city: 'Yountville', state: 'CA', country: 'United States' }],
    map: {
      center: {
        lat: 37.7928918,
        lng: -122.4003734
      },
      zoom: 13,
      scrollwheel: false,
      mapTypeControl: false,
      streetViewControl: false,
      panControl: false,
      zoomControl: true
    }
  },
  'Los Angeles,CA,United States': {
    searchLocation: 'Los Angeles',
    area: 'Greater Los Angeles',
    aliases: [{ city: 'Beverly Hills', state: 'CA', country: 'United States' }, { city: 'Costa Mesa', state: 'CA', country: 'United States' }, { city: 'Culver City', state: 'CA', country: 'United States' }, { city: 'Glendale', state: 'CA', country: 'United States' }, { city: 'Long Beach', state: 'CA', country: 'United States' }, { city: 'Los Angeles', state: 'CA', country: 'United States' }, { city: 'Mailibu', state: 'CA', country: 'United States' }, { city: 'Manhattan Beach', state: 'CA', country: 'United States' }, { city: 'Marina del Ray', state: 'CA', country: 'United States' }, { city: 'Newport Beach', state: 'CA', country: 'United States' }, { city: 'Santa Monica', state: 'CA', country: 'United States' }, { city: 'West Hollywood', state: 'CA', country: 'United States' }],
    map: {
      center: {
        lat: 34.0815186,
        lng: -118.3741051
      },
      zoom: 13,
      scrollwheel: false,
      mapTypeControl: false,
      streetViewControl: false,
      panControl: false,
      zoomControl: true
    }
  },
  'Chicago,IL,United States': {
    searchLocation: 'Chicago',
    area: 'Chicago',
    aliases: [{
      city: 'Chicago',
      state: 'IL',
      country: 'United States'
    }],
    map: {
      center: {
        lat: 41.8582854,
        lng: -87.7347105
      },
      zoom: 13,
      scrollwheel: false,
      mapTypeControl: false,
      streetViewControl: false,
      panControl: false,
      zoomControl: true
    }
  },
  'Atlanta,GA,United States': {
    searchLocation: 'Atlanta',
    area: 'Atlanta',
    aliases: [{
      city: 'Atlanta',
      state: 'GA',
      country: 'United States'
    }]
  },
  'Las Vegas,NV,United States': {
    searchLocation: 'Las Vegas',
    area: 'Las Vegas',
    aliases: [{
      city: 'Las Vegas',
      state: 'NV',
      country: 'United States'
    }]
  },
  'London,England,United Kingdom': {
    searchLocation: 'London',
    area: 'London',
    aliases: [{
      city: 'London',
      state: 'England',
      country: 'United Kingdom'
    }]
  },
  'Dallas,TX,United States': {
    searchLocation: 'Dallas',
    area: 'Dallas',
    aliases: [{
      city: 'Dallas',
      state: 'TX',
      country: 'United States'
    }]
  },
  'Denver,CO,United States': {
    searchLocation: 'Denver',
    area: 'Denver',
    aliases: [{
      city: 'Denver',
      state: 'CO',
      country: 'United States'
    }]
  },
  'Miami,FL,United States': {
    searchLocation: 'Miami',
    area: 'Miami',
    aliases: [{
      city: 'Miami',
      state: 'FL',
      country: 'United States'
    }]
  },
  'Nashville,TN,United States': {
    searchLocation: 'Nashville',
    area: 'Nashville',
    aliases: [{
      city: 'Nashville',
      state: 'TN',
      country: 'United States'
    }]
  },
  'Austin,TX,United States': {
    searchLocation: 'Austin',
    area: 'Austin',
    aliases: [{
      city: 'Austin',
      state: 'TX',
      country: 'United States'
    }]
  },
  'Houston,TX,United States': {
    searchLocation: 'Houston',
    area: 'Houston',
    aliases: [{
      city: 'Houston',
      state: 'TX',
      country: 'United States'
    }]
  },
  'Seattle, WA, United States': {
    searchLocation: 'Seattle',
    area: 'Seattle',
    aliases: [{
      city: 'Seattle',
      state: 'WA',
      country: 'United States'
    }]
  },
  'Philadelphia, PA, United States': {
    searchLocation: 'Philadelphia',
    area: 'Philadelphia',
    aliases: [{
      city: 'Philadelphia',
      state: 'PA',
      country: 'United States'
    }]
  },
  'New Orleans, LA, United States': {
    searchLocation: 'New Orleans',
    area: 'New Orleans',
    aliases: [{
      city: 'New Orleans',
      state: 'LA',
      country: 'United States'
    }]
  },
  'Charleston, SC, United States': {
    searchLocation: 'Charleston',
    area: 'Charleston',
    aliases: [{
      city: 'Charleston',
      state: 'SC',
      country: 'United States'
    }]
  },
  'Charlotte, NC, United States': {
    searchLocation: 'Charlotte',
    area: 'Charlotte',
    aliases: [{
      city: 'Charlotte',
      state: 'NC',
      country: 'United States'
    }]
  },
  'Cleveland, OH, United States': {
    searchLocation: 'Cleveland',
    area: 'Cleveland',
    aliases: [{
      city: 'Cleveland',
      state: 'OH',
      country: 'United States'
    }]
  },
  'Detroit,MI, United States': {
    searchLocation: 'Detroit',
    area: 'Detroit',
    aliases: [{
      city: 'Detroit',
      state: 'MI',
      country: 'United States'
    }]
  },
  'San Diego,CA,United States': {
    searchLocation: 'San Diego',
    area: 'San Diego',
    aliases: [{
      city: 'San Diego',
      state: 'CA',
      country: 'United States'
    }]
  },
  'Baltimore, MD, United States': {
    searchLocation: 'Baltimore',
    area: 'Baltimore',
    aliases: [{
      city: 'Baltimore',
      state: 'MD',
      country: 'United States'
    }]
  },
  'Milwaukee, WI, United States': {
    searchLocation: 'Milwaukee',
    area: 'Milwaukee',
    aliases: [{
      city: 'Milwaukee',
      state: 'WI',
      country: 'United States'
    }]
  },
  'Minneapolis, MN, United States': {
    searchLocation: 'Minneapolis',
    area: 'Minneapolis',
    aliases: [{
      city: 'Minneapolis',
      state: 'MN',
      country: 'United States'
    }]
  },
  'Orlando, FL, United States': {
    searchLocation: 'Orlando',
    area: 'Orlando',
    aliases: [{
      city: 'Orlando',
      state: 'FL',
      country: 'United States'
    }]
  },
  'Phoenix, AZ, United States': {
    searchLocation: 'Phoenix',
    area: 'Phoenix',
    aliases: [{
      city: 'Phoenix',
      state: 'AZ',
      country: 'United States'
    }]
  },
  'Salt Lake City, UT, United States': {
    searchLocation: 'Salt Lake City',
    area: 'Salt Lake City',
    aliases: [{
      city: 'Salt Lake City',
      state: 'UT',
      country: 'United States'
    }]
  },
  'St. Louis, MO, United States': {
    searchLocation: 'St. Louis',
    area: 'St. Louis',
    aliases: [{
      city: 'St. Louis',
      state: 'MO',
      country: 'United States'
    }]
  },
  'Portland, OR, United States': {
    searchLocation: 'Portland',
    area: 'Portland',
    aliases: [{
      city: 'Portland',
      state: 'OR',
      country: 'United States'
    }]
  },
  'Portland, ME, United States': {
    searchLocation: 'Portland',
    area: 'Portland',
    aliases: [{
      city: 'Portland',
      state: 'ME',
      country: 'United States'
    }]
  },
  'Pittsburgh': {
    searchLocation: 'Pittsburgh',
    area: 'Pittsburgh',
    aliases: [{
      city: 'Pittsburgh',
      state: 'PA',
      country: 'United States'
    }]
  }
};